export namespace IMtList {
  export enum ETaskState {
    // 初始化
    Init = 0,
    // 待翻译
    Loading = 1,
    // 翻译中
    Working = 2,
    // 翻译完成
    Done = 3,
    // 翻译失败
    Fail = 4
  }
  export interface IMtListRes {
    // 创建时间
    createDt: string
    // 文件id
    fileId: string
    id: string
    // 语种
    language: string
    // 文件名
    name: string
    // 文件大小
    size: string
    // 状态
    status: ETaskState
    // 文件后缀
    suffix: string
    // 任务id
    taskId?: string
    // 进度
    progress?: number
  }

  export interface ICreateTaskReq {
    fileId: string
    language: string
  }

  export interface IProgressRes {
    id: string
    status: IMtList.ETaskState
    progress: number
  }
}

export namespace IMtOnline {
  export interface ITranslateReq {
    content: string
    language: string
  }
}

export namespace IMtRes {
  export interface IMtResReq {
    // 文件id
    fileId?: string
    // 任务id
    id?:string
  }
  interface IContentItem {
    origin: string
    translated: string
  }
  export interface IMtUpdateReq {
    content: IContentItem[]
    id: string
  }
  export interface ISegmentsItem {
    origin: string
    translated: string
  }
  export interface ITranslateRes {
    // 原文件语种
    from: string
    // 目标文件语种
    to: string
    // id
    id: string
    // 文件名称
    name: string
    // 结果
    segments: ISegmentsItem[]
    // 翻译方向
    des: string
  }
}
export interface ILanguageTypeRes {
  // 语言描述
  des: string
  // 配置串id
  id: string
  // 转换类型(cn2en)
  name: string
  // 原语言类型
  origin: string
  // 配置串
  property: string
  // 目标语言类型
  target: string
}
